<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Dashboard de Negócio</h3>
        </div>
      </div>
      <d-row>
        <!-- Cards -->
        <d-col v-for="(card, index) in Cards" :key="index" md="6" lg="3" class="mb-4">
          <cards :id="`card-${index}`" :link="card.link" :label="card.label" :value="card.value" />
        </d-col>
      </d-row>
      <div v-if="loading">
        <loader :is-loading="loading" />
      </div>
      <div class="row equal-cols" v-else>
        <d-col class="mb-12 col-lg-12 lg-s" style="margin-bottom: 30px">
          <d-card class="card-small">
            <!-- Card Header -->
            <d-card-header class="border-bottom">
              <div class="float-left">
                <h6 class="m-0">Geolocalização dos clientes e parceiros</h6>
              </div>
            </d-card-header>
            <d-card-body class="p-0" style="padding: 10px !important">
              <GmapMap
                ref="mapRef"
                :center="{lat:-15.5056793, lng:-52.153478}"
                :zoom="3"
                :options="{zoomControl: true, mapTypeControl: false, scaleControl: false, streetViewControl: false, rotateControl: false, fullscreenControl: true, disableDefaultUI: false }"
                map-type-id="terrain"
                style="width: 100%; height: 450px;|"
              >
                <GmapCluster>
                  <GmapMarker
                    :key="index"
                    v-for="(m, index) in infoDashboard.MerchantGeo"
                    :position="m.position"
                    :clickable="true"
                    :draggable="false"
                    :icon="m.icon"
                    :title="m.title"
                    @click="ViewMerchant(m,index)"
                  />
                </GmapCluster>
              </GmapMap>
            </d-card-body>
          </d-card>
        </d-col>

        <d-col class="mb-4 col-lg-6 lg-s">
          <d-row
            v-if="this.infoDashboard.MerchantsRoot != null && this.infoDashboard.MerchantsRoot.length > 0"
          >
            <d-col class="mb-12 col-lg-12 lg-s">
              <chart-card type="line" title="Clientes diretos" :chartData="chartMerchantRoot"></chart-card>
            </d-col>
          </d-row>
          <br />
          <d-row
            v-if="this.infoDashboard.Merchants != null && this.infoDashboard.Merchants.length > 0"
          >
            <d-col class="mb-12 col-lg-12 lg-s">
              <d-card class="card-small">
                <!-- Card Header -->
                <d-card-header class="border-bottom">
                  <div class="float-left">
                    <h6 class="m-0">Top 10 Clientes</h6>
                  </div>
                  <div class="float-right">
                    <i class="fas fa-dollar-sign"></i>
                  </div>
                </d-card-header>
                <d-card-body class="p-0">
                  <!-- Services List Group -->
                  <d-list-group flush class="list-group-small">
                    <d-list-group-item
                      v-for="(item, index) in this.infoDashboard.Merchants"
                      :key="index"
                      class="d-flex px-3"
                    >
                      <i
                        v-if="item.Position > 0 && item.Position < 4"
                        :class="['fas fa-medal mt-1 mr-2 padding-right-item', GetIconColorClass(item.Position)]"
                      ></i>
                      <span
                        v-if="item.Position > 3"
                        class="text-semibold text-nowrap text-fiord-blue ml-1 padding-right-item"
                      >{{ item.Position }}</span>
                      <span
                        :title="item.Merchant.Name"
                        v-b-tooltip.hover.bottom
                        class="text-semibold text-nowrap text-fiord-blue text-ellipsis"
                      >{{ item.Merchant.Name}}</span>
                      <span
                        class="ml-auto text-nowrap text-right text-semibold padding-left-item"
                      >{{ item.Amount | currency }}</span>
                    </d-list-group-item>
                  </d-list-group>
                </d-card-body>
                <d-card-footer class="border-top"></d-card-footer>
              </d-card>
            </d-col>
          </d-row>
          <br />
          <d-row
            v-if="this.infoDashboard.Partners != null && this.infoDashboard.Partners.length > 0"
          >
            <d-col class="mb-12 col-lg-12 lg-s">
              <d-card class="card-small">
                <!-- Card Header -->
                <d-card-header class="border-bottom">
                  <div class="float-left">
                    <h6 class="m-0">Top 10 Parceiros</h6>
                  </div>
                  <div class="float-right">
                    <i class="fas fa-hand-holding-usd"></i>
                  </div>
                </d-card-header>
                <d-card-body class="p-0">
                  <!-- Services List Group -->
                  <d-list-group flush class="list-group-small">
                    <d-list-group-item
                      v-for="(item, index) in this.infoDashboard.Partners"
                      :key="index"
                      class="d-flex px-3"
                    >
                      <i
                        v-if="item.Position > 0 && item.Position < 4"
                        :class="['fas fa-medal mt-1 mr-2 padding-right-item', GetIconColorClass(item.Position)]"
                      ></i>
                      <span
                        v-if="item.Position > 3"
                        class="text-semibold text-nowrap text-fiord-blue ml-1 padding-right-item"
                      >{{ item.Position }}</span>
                      <span
                        :title="item.Partner.Name"
                        v-b-tooltip.hover.bottom
                        class="text-semibold text-nowrap text-fiord-blue text-ellipsis"
                      >{{ item.Partner.Name }}</span>
                      <span
                        class="ml-auto text-nowrap text-right text-semibold padding-left-item"
                      >{{ item.Amount | currency }}</span>
                    </d-list-group-item>
                  </d-list-group>
                </d-card-body>
                <d-card-footer class="border-top"></d-card-footer>
              </d-card>
            </d-col>
          </d-row>
        </d-col>
        <d-col class="mb-4 col-lg-6 lg-s">
          <d-row
            v-if="this.infoDashboard.MerchantsChart != null && this.infoDashboard.MerchantsChart.length > 0"
          >
            <d-col class="mb-12 col-lg-12 lg-s">
              <chart-card type="line" title="Total de clientes" :chartData="chartMerchant"></chart-card>
            </d-col>
          </d-row>
          <br />
          <d-row v-if="this.infoDashboard.Cnaes != null && this.infoDashboard.Cnaes.length > 0">
            <d-col class="mb-12 col-lg-12 lg-s">
              <d-card class="card-small">
                <!-- Card Header -->
                <d-card-header class="border-bottom">
                  <div class="float-left">
                    <h6 class="m-0">Top 10 CNAES</h6>
                  </div>
                  <div class="float-right">
                    <i class="fas fa-bars"></i>
                  </div>
                </d-card-header>
                <d-card-body class="p-0">
                  <!-- Services List Group -->
                  <d-list-group flush class="list-group-small">
                    <d-list-group-item
                      v-for="(item, index) in this.infoDashboard.Cnaes"
                      :key="index"
                      class="d-flex px-3"
                    >
                      <i
                        v-if="item.Position > 0 && item.Position < 4"
                        :class="['fas fa-medal mt-1 mr-2 padding-right-item', GetIconColorClass(item.Position)]"
                      ></i>
                      <span
                        v-if="item.Position > 3"
                        class="text-semibold text-nowrap text-fiord-blue ml-1 padding-right-item"
                      >{{ item.Position }}</span>
                      <span
                        :title="item.Merchant.CNAE"
                        v-b-tooltip.hover.bottom
                        class="text-semibold text-nowrap text-fiord-blue text-ellipsis"
                      >{{ item.Merchant.CNAE }}</span>
                      <span
                        class="ml-auto text-nowrap text-right text-semibold padding-left-item"
                      >{{ item.Quantity | number }}</span>
                    </d-list-group-item>
                  </d-list-group>
                </d-card-body>
                <d-card-footer class="border-top"></d-card-footer>
              </d-card>
            </d-col>
          </d-row>
          <br />
        </d-col>
      </div>
    </div>
    <a
      href="#"
      class="btn-float btn-primary"
      v-show="showBtnScroll"
      v-on:click="ScrollToTop($event)"
    >
      <i class="fa fa-chevron-up"></i>
    </a>
  </div>
</template>

<script>
import cards from "@/components/common/cards";
import chartCard from "@/components/common/chart-card";

export default {
  name: "business-dashboard",
  components: {
    cards,
    chartCard
  },
  data: function() {
    return {
      loading: false,
      infoDashboard: {
        QuantityPartner: 0,
        QuantityProspect: 0,
        QuantityMerchantRoot: 0,
        QuantityMerchant: 0,
        QuantityMerchantRootProfit: 0,
        QuantityMerchantProfit: 0,
        Partners: [],
        Merchants: [],
        Cnaes: [],
        MerchantsRoot: [],
        MerchantsChart: [],
        MerchantGeo: [],
        PartnerGeo: []
      },
      chartMerchantRoot: {
        labels: [],
        datasets: []
      },
      chartMerchant: {
        labels: [],
        datasets: []
      },
      showBtnScroll: false
    };
  },
  created() {
    window.addEventListener("scroll", this.HandleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.HandleScroll);
  },
  computed: {
    Cards() {
      return [
        {
          label: "Negociações em andamento",
          value: this.$options.filters.number(
            this.infoDashboard.QuantityProspect
          )
        },
        {
          label: "Clientes diretos",
          value:
            this.$options.filters
              .number(this.infoDashboard.QuantityMerchantRootProfit)
              .toString() +
            "/" +
            this.$options.filters
              .number(this.infoDashboard.QuantityMerchantRoot)
              .toString()
        },
        {
          label: "Total de Clientes",
          value:
            this.$options.filters
              .number(this.infoDashboard.QuantityMerchantProfit)
              .toString() +
            "/" +
            this.$options.filters
              .number(this.infoDashboard.QuantityMerchant)
              .toString()
        },
        {
          label: "Parceiros",
          value: this.$options.filters.number(
            this.infoDashboard.QuantityPartner
          )
        }
        /*{
          label: "Total de Clientes inativos",
          value: this.$options.filters.number(
            this.infoDashboard.QuantityMerchantNotTransacting
          ),
          link: {
            component: 'clients-not-transacting'
          }
        }*/
      ];
    }
  },
  watch: {},
  mounted() {
    this.GetBusinessDashboard();
    this.$root.$on("bv::tooltip::show", bvEvent => {
      if (bvEvent.target.offsetWidth == bvEvent.target.scrollWidth)
        bvEvent.preventDefault();
    });
  },
  methods: {
    ViewMerchant: function(merchant, idx) {
      if (merchant.isPartner) {
        this.$router.push({
          name: "merchants",
          query: {
            idPartner: merchant.code
          }
        });
      } else {
        var dt = new Date();
        dt.setMonth(dt.getMonth() - 1);

        this.$router.push({
          name: "profit",
          params: { idMerchant: merchant.code },
          query: {
            paymentDate: this.$options.filters.date(dt, "YYYY-MM-DD")
          }
        });
      }
    },
    GetIconColorClass: function(position) {
      let colorClass;
      if (position == 1) {
        colorClass = "icon-gold";
      } else if (position == 2) {
        colorClass = "icon-silver";
      } else if (position == 3) {
        colorClass = "icon-bronze";
      }
      return colorClass;
    },
    GetBusinessDashboard: function() {
      this.loading = true;
      this.$store
        .dispatch("GetBusinessDashboard")
        .then(response => {
          this.infoDashboard = response;

          let date = new Date();
          let label = "Quantidade";
          let borderColor = "rgba(26, 45, 91, 0.8)";
          let backgroundColor = "rgba(0, 101, 179, 0.3)";

          this.chartMerchantRoot = {
            labels: [],
            datasets: []
          };
          if (
            this.infoDashboard.MerchantsRoot != null &&
            this.infoDashboard.MerchantsRoot != undefined
          ) {
            let merchantsRootSlice = this.SliceArray(
              this.infoDashboard.MerchantsRoot
            );
            let datasetRoot = {
              label: label,
              borderColor: borderColor,
              backgroundColor: backgroundColor,
              data: []
            };
            merchantsRootSlice.forEach(element => {
              this.chartMerchantRoot.labels.push(
                new Date(
                  date.getUTCFullYear(),
                  element.CreatedMonth - 1,
                  1
                ).getShortMonthName() +
                  `/${element.CreatedYear.toString().substring(2, 4)}`
              );
              datasetRoot.data.push({
                x: element.CreatedMonth - 1,
                y: element.Quantity
              });
            });
            this.chartMerchantRoot.datasets.push(datasetRoot);
          }

          this.chartMerchant = {
            labels: [],
            datasets: []
          };
          if (
            this.infoDashboard.MerchantsChart != null &&
            this.infoDashboard.MerchantsChart != undefined
          ) {
            let merchantsSlice = this.SliceArray(
              this.infoDashboard.MerchantsChart
            );
            let datasetMerchant = {
              label: label,
              borderColor: borderColor,
              backgroundColor: backgroundColor,
              data: []
            };
            merchantsSlice.forEach(element => {
              this.chartMerchant.labels.push(
                new Date(
                  date.getUTCFullYear(),
                  element.CreatedMonth - 1,
                  1
                ).getShortMonthName() +
                  `/${element.CreatedYear.toString().substring(2, 4)}`
              );
              datasetMerchant.data.push({
                x: element.CreatedMonth - 1,
                y: element.Quantity
              });
            });
            this.chartMerchant.datasets.push(datasetMerchant);
          }
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar o Dashboard",
            error
          );
        })
        .finally(() => (this.loading = false));
    },
    SliceArray: function(list, max = 10) {
      let count = list.length;
      var listSlice;
      if (count > max) listSlice = list.slice(count - max, count);
      else listSlice = list;
      return listSlice;
    },
    HandleScroll: function() {
      if (
        document.body.scrollTop > 400 ||
        document.documentElement.scrollTop > 400
      ) {
        this.showBtnScroll = true;
      } else {
        this.showBtnScroll = false;
      }
    },
    ScrollToTop: function() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style scoped>
.padding-right-item {
  padding-right: 10px;
}
.padding-left-item {
  padding-left: 35px;
}
.icon-gold {
  color: #edd05c;
}
.icon-silver {
  color: #9ea5b5;
}
.icon-bronze {
  color: #e09848;
}
</style>
<style>
.tooltip-inner {
  font-size: 10pt;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/businessDashboard.vue